import { createTheme } from "@mui/material";
import { Colors } from "constants/constants";

export const theme = createTheme({
  palette: {
    primary: {
      main: Colors.turquoise,
    },
  },
});
